<template>
    <el-container direction="vertical">
        <el-col justify="start" class="pr10">
            <el-form :model="expense" label-position="top" v-if="isDataLoaded">
                <div class="expense-main">
                    <div class="title">
                        Расход по сделке
                    </div>
                    <template v-if="!isNew">
                        <el-row class="mb10 first-row">
                            <el-col :span="8" class="gray">
                                Сделка
                            </el-col>
                            <el-col :span="16">
                                <a :href="getDealLink(expense.deal_id)" target="_blank" class="link">
                                    #{{ expense.deal_id }}
                                </a>
                            </el-col>
                        </el-row>
                        <el-row class="mb10">
                            <el-col :span="8" class="gray">
                                Договор
                            </el-col>
                            <el-col :span="16">
                                {{ this.expense.deal.contract_number }}
                            </el-col>
                        </el-row>
                        <el-row class="mb10">
                            <el-col :span="8" class="gray">
                                Адрес
                            </el-col>
                            <el-col :span="16">
                                {{ this.expense.deal.address }}
                            </el-col>
                        </el-row>
                    </template>
                    <el-row :class="['mb10', {'first-row' : isNew}]">
                        <el-col :span="8" class="gray">
                            Отчётный период
                        </el-col>
                        <el-col :span="16" class="period-select">
                            <div class="filter-label">
                                Год
                            </div>
                            <el-select
                                v-model="expense.period_year"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                placeholder="Год"
                                size="mini"
                                class="period-select-year"
                            >
                                <el-option v-for="item in localReferences.yearsList" :key="item" :label="item" :value="item" />
                            </el-select>
                            <div class="filter-label">
                                Месяц
                            </div>
                            <el-select
                                v-model="expense.period_month"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                clearable
                                placeholder="Месяц"
                                size="mini"
                                class="period-select-month"
                            >
                                <el-option v-for="item in localReferences.monthsList" :key="item" :label="item" :value="item" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Источник расхода
                        </el-col>
                        {{ this.getName(this.receivedByTypesList, expense.source_type) }}
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Касса
                        </el-col>
                        <el-col :span="8">
                            <el-select
                                v-model="expense.source_office_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                collapse-tags
                                clearable
                                autocomplete
                                size="mini"
                            >
                                <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>
                        <el-col :span="1" class="gray">
                            &nbsp;
                        </el-col>
                        <el-col :span="7">
                            <el-select
                                v-model="expense.source_pay_type_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                collapse-tags
                                clearable
                                autocomplete
                                size="mini"
                            >
                                <el-option v-for="item in payTypesList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Получил - тип
                        </el-col>
                        <template v-if="!isNew">
                            <el-col :span="16" class="simple-text">
                                {{ this.getName(this.receivedFromTypesList, expense.recipient_type) }}
                            </el-col>
                        </template>
                        <template v-else>
                            <el-col :span="16">
                                <el-select
                                    v-model="expense.recipient_type"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    clearable
                                    size="mini"
                                    @change="setRecipientIdByRecipientType(expense.recipient_type)"
                                >
                                    <el-option v-for="item in receivedFromTypesListDeal" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </el-col>
                        </template>
                    </el-row>
                    <el-row class="mb10">
                        <template v-if="expense.recipient_type !== localReferences.expenseRecipient.cash">
                            <el-col :span="8" class="gray">
                                Получил
                            </el-col>
                            <el-col :span="16">
                                <template v-if="expense.recipient_type !== localReferences.expenseRecipient.contact">
                                    <el-select
                                        v-model="expense.recipient_id"
                                        placement="bottom"
                                        popper-class="popper-dropdown"
                                        autocomplete
                                        size="mini"
                                    >
                                        <el-option v-for="item in receivedByIdList" :key="item.id" :label="item.name" :value="item.id" />
                                    </el-select>
                                </template>
                                <template v-else>
                                    {{ recipient_name }}
                                </template>
                            </el-col>
                        </template>
                        <template v-else>
                            <el-col :span="8" class="gray">
                                &nbsp;
                            </el-col>
                            <el-col :span="8">
                                <el-select
                                    v-model="expense.recipient_office_id"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    collapse-tags
                                    clearable
                                    autocomplete
                                    size="mini"
                                >
                                    <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </el-col>
                            <el-col :span="1" class="gray">
                                &nbsp;
                            </el-col>
                            <el-col :span="7">
                                <el-select
                                    v-model="expense.recipient_pay_type_id"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    collapse-tags
                                    clearable
                                    autocomplete
                                    size="mini"
                                >
                                    <el-option v-for="item in payTypesList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </el-col>
                        </template>
                    </el-row>
                    <div class="mb10" v-for="value in expense.details" :key="value.id">
                        <el-row class="mb10">
                            <template v-if="!isNew">
                                <el-col :span="8" class="gray">
                                    {{ getExpenseTypeName(value.expense_type) }}
                                </el-col>
                            </template>
                            <template v-else>
                                <el-col :span="8" class="gray">
                                    Статья
                                </el-col>
                                <el-col :span="8" class="gray">
                                    <el-select
                                        v-model="value.expense_type"
                                        placement="bottom"
                                        popper-class="popper-dropdown"
                                        collapse-tags
                                        clearable
                                        size="mini"
                                    >
                                        <el-option v-for="item in expenseTypeListComputed" :key="item.id" :label="item.name" :value="item.id" />
                                    </el-select>
                                </el-col>
                            </template>
                            <el-col :span="!isNew ? 16 : 8" :class="[{'expense-detail-amount': isNew}, 'gray']">
                                <auto-numeric
                                    v-model="value.amount"
                                    :options="getNumericOptions(value.expense_type)"
                                    :class="[
                                        'autonumeric'
                                    ]"
                                />
                            </el-col>
                        </el-row>
                    </div>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Дата расхода
                        </el-col>
                        <el-col :span="16">
                            <el-date-picker
                                v-model="expense.date"
                                type="date"
                                placeholder="дд.мм.гггг"
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                :clearable="false"
                                size="mini"
                                class="w100"
                            />
                            <div class="field-error bold" v-if="errors.date" v-text="errors.date[0]"></div>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Комментарий
                        </el-col>
                        <el-col :span="16" class="gray">
                            <el-input
                                size="mini"
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder=""
                                v-model="expense.comment"
                            />
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Сумма,руб
                        </el-col>
                        <el-col :span="16" class="simple-text">
                            {{ calculateAmount !== 0 ? formatFinance(calculateAmount) : 0 }}
                        </el-col>
                    </el-row>
                    <el-row class="text-center pt16">
                        <el-col>
                            <template v-if="!isNew">
                                <el-button type="warning" @click="save">
                                    Применить
                                </el-button>
                            </template>
                            <template v-else>
                                <el-button type="warning" @click="create">
                                    Создать
                                </el-button>
                            </template>
                            <el-button type="info" @click="close">
                                Отменить
                            </el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </el-col>
    </el-container>
</template>
<script>
import AutoNumeric from '@/components/autonumeric/VueAutonumeric';
import ExpenseMixin from '@/mixins/expense';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { pickerOptions } from '@/common/pickerOptions';
import moment from 'moment';
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly';
import '@/assets/styles/card.scss';
import { formatFinance } from '@/common/utilities';
import localReferences from '@/helpers/localReferences';
import _ from 'lodash';

const initialExpense = {
    id: null,
    created_by_id: null,
    created_at: moment().format('DD.MM.YYYY HH:mm'),
    amount: 0,
    amount_formatted: ''
};

export default {
    name: 'MassExpenseDealEdit',
    components: {
        AutoNumeric
    },
    mixins: [
        ExpenseMixin
    ],
    props: {
        id: {
            type: [String, Number],
            default: 0
        },
        dealId: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            recipient_name: this.$store.state.deals.current.contact.name,
            expense: {
                id: null,
                created_at: null,
                created_by_id: this.$store.state.auth.employerId,
                date: null,
                recipient_type: '',
                recipient_id: null,
                deal_id: this.dealId,
                deal: {
                    contract_number: ''
                },
                source_type: 'cash',
                source_id: null,
                source_office_id: null,
                source_pay_type_id: null,
                recipient_office_id: null,
                recipient_pay_type_id: null,
                pay_type_id: 1,
                period_year: '',
                period_month: '',
                report_date: '',
                details: [{
                    expense_type: null,
                    amount: 0
                }],
                comment: '',
                amount: 0
            },
            created_by_name: '',
            errors: [],
            loadingMain: false,
            period: [],
            isSaveButtonPressed: false,
            counter: 0,
            amount: 0,
            isDataLoaded: 0,
            expenseDetails: [{ expense_type: null, amount: 0 }],
            expenseDetailsReady: 0
        };
    },
    computed: {
        isNew() {
            return this.id === -1;
        },
        calculateAmount() {
            let amount = 0;
            if (this.expense.details !== undefined) {
                amount = this.expense.details.reduce((previousValue, currentValue) => previousValue + currentValue.amount, amount);
            }
            return amount;
        },
        isEdit() {
            return true;
        },
        getExpenseDealId() {
            if (this.expense.deal !== undefined) {
                return this.expense.deal.id;
            }
            return '';
        },
        getContractNumber() {
            if (this.expense.deal !== undefined) {
                return this.expense.deal.contract_number;
            }
            return '';
        },
        getDealAddress() {
            if (this.expense.deal !== undefined) {
                return this.expense.deal.address;
            }
            return '';
        },
        expenseTypeListComputed() {
            if (this.expense.recipient_type === 'contact') {
                const contractorExpenses = ['refund_to_client'];
                return this.expenseTypeList.filter(item => contractorExpenses.includes(item.id));
            }
            const dealExpenses = ['bonus_1_percent', 'bonus_deal', 'fine_deal', 'bonus_measurer', 'finish', 'jalousie', 'complaint_materials', 'complaint_work', 'refund_to_client', 'production'];
            return this.expenseTypeList.filter(item => dealExpenses.includes(item.id));
        },
        recipientOfficeId() {
            return this.expense.recipient_office_id;
        },
        recipientPayTypeId() {
            return this.expense.recipient_pay_type_id;
        },
        sourceOfficeId() {
            return this.expense.source_office_id;
        },
        sourcePayTypeId() {
            return this.expense.source_pay_type_id;
        }
    },
    beforeMount() {
        if (!this.isNew) {
            this.getDealExpenses();
        } else {
            this.isDataLoaded = 1;
        }
    },
    methods: {
        formatFinance,
        getDealLink(dealId) {
            return this.$router.resolve({ name: 'deal-card', params: { id: '' + dealId } }).href;
        },
        async getDealExpenses() {
            this.loadingMain = true;
            try {
                const remoteExpense = await this.$store.dispatch('expenses/getExpense', this.id);
                Object.keys(this.expense).map(exp => {
                    this.expense[exp] = remoteExpense[exp];
                });
                this.isDataLoaded = 1;
                if (!this.isNew) {
                    this.setCashParams();
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.loadingMain = false;
            }
        },
        getOfficeName() {
            const expense = this.expense;
            if (expense.deal !== null) {
                return expense.deal.responsible_user.office_name;
            }
        },
        open() {
            return true;
        },
        close() {
            this.$emit('closePopUp', false);
        },
        async updateExpense() {
            this.loadingMain = true;
            try {
                var amount = 0;
                this.expense.amount = amount;
                this.expense.report_date = this.getPeriod();
                this.expense = await this.$store.dispatch('expenses/updateDealExpenses', { ...this.expense });
                this.actionAfterSave();
                this.$emit('getDataFromServer');
            } catch (e) {
                this.errors = JSON.parse(e.message);
                this.actionAfterSaveError();
            } finally {
                this.loadingMain = false;
            }
        },
        save() {
            this.updateExpense();
        },
        actionAfterSave() {
            this.$message({
                showClose: true,
                message: 'Расход сохранён',
                type: 'success',
                duration: 5000,
                customClass: this.alertClass()
            });
            this.$emit('closePopUp', false);
        },
        actionAfterSaveError() {
            this.$message({
                showClose: true,
                message: 'Расход не сохранён',
                type: 'error',
                duration: 5000,
                customClass: this.alertClass()
            });
        },
        getNumericOptions(expenseType) {
            if (expenseType === 'fine_deal') {
                return [this.numericOptions, { minimumValue: '-9999999999999', maximumValue: 0 }];
            }
            if (expenseType === 'complaint_work' || expenseType === 'complaint_materials') {
                return [this.numericOptions, { minimumValue: '-9999999999999' }];
            }
            return this.numericOptions;
        },
        getExpenseTypeName(expenseType) {
            if (expenseType === null) return '';
            return this.expenseTypeList.filter(item => item.id === expenseType)[0].name;
        },
        async createExpense() {
            this.loadingMain = true;
            try {
                if (this.expense.details.length > 0) {
                    this.expense.amount = (this.expense.details.reduce((previousValue, currentValue) => previousValue + currentValue.amount), 0);
                }
                this.expense.report_date = this.getPeriod();
                this.expense = await this.$store.dispatch('expenses/createExpense', { ...this.expense });
                this.actionAfterSave();
                this.$emit('getDataFromServer');
            } catch (e) {
                this.errors = JSON.parse(e.message);
                this.actionAfterSaveError();
            } finally {
                this.loadingMain = false;
            }
        },
        create() {
            this.createExpense();
        },
        setCashParams() {
            if (this.expense.source_type === localReferences.expenseSource.cash) {
                const cash = this.getCash(this.expense.source_id);
                if (cash) {
                    this.expense.source_pay_type_id = cash.pay_type_category_id;
                    this.expense.source_office_id = cash.office_id;
                }
            }
            if (this.expense.recipient_type === localReferences.expenseRecipient.cash) {
                const cash = this.getCash(this.expense.recipient_id);
                if (cash) {
                    this.expense.recipient_pay_type_id = cash.pay_type_category_id;
                    this.expense.recipient_office_id = cash.office_id;
                }
            }
        },
        setRecipientIdByRecipientType(recipientType) {
            if (this.isNew) {
                if (recipientType === 'contact') {
                    this.expense.recipient_id = this.$store.state.deals.current.contact.id;
                } else {
                    this.expense.recipient_id = '';
                }
            }
        }
    },
    watch: {
        recipientOfficeId: function(val, oldVal) {
            if (this.expense.recipient_type !== localReferences.expenseRecipient.cash) {
                return;
            }
            if (this.expense.recipient_pay_type_id) {
                const cash = this.getCashByParams(this.expense.recipient_pay_type_id, val);
                this.expense.recipient_id = cash ? cash.id : null;
                this.expense.pay_type_id = cash ? cash.pay_type_category_id : null;
            }
        },
        recipientPayTypeId: function(val, oldVal) {
            if (this.expense.recipient_type !== localReferences.expenseRecipient.cash) {
                return;
            }
            if (this.expense.recipient_office_id) {
                const cash = this.getCashByParams(val, this.expense.recipient_office_id);
                this.expense.recipient_id = cash ? cash.id : null;
                this.expense.pay_type_id = cash ? cash.pay_type_category_id : null;
            }
        },
        sourceOfficeId: function(val, oldVal) {
            if (this.expense.source_type !== localReferences.expenseSource.cash) {
                return;
            }
            if (this.expense.source_pay_type_id) {
                this.expense.source_id = this.getCashId(this.expense.source_pay_type_id, val);
            }
        },
        sourcePayTypeId: function(val, oldVal) {
            if (this.expense.source_type !== localReferences.expenseSource.cash) {
                return;
            }
            if (this.expense.source_office_id) {
                this.expense.source_id = this.getCashId(val, this.expense.source_office_id);
            }
        }
    }
};
</script>
